const toastOptions = {
  position: "top-right",
  duration: 2000,
};

export default toastOptions;
